export default {
  path: "/",
  component: () =>
    import(/* webpackChunkName: "guest" */ "@/layouts/Guest.vue"),
  children: [
    {
      path: "",
      name: "Home",
      component: () =>
        import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
    },
    {
      path: "error",
      name: "Error",
      component: () =>
        import(/* webpackChunkName: "error" */ "@/views/Error.vue"),
    },
    {
      path: "terms-of-use",
      name: "TermsOfUse",
      component: () =>
        import(/* webpackChunkName: "terms" */ "@/views/TermsOfUse.vue"),
    },
    {
      path: "partner-terms-of-use",
      name: "PartnerTermsOfUse",
      component: () =>
        import(
          /* webpackChunkName: "partner-terms" */ "@/views/Doctor/TermsOfUse.vue"
        ),
    },
    {
      path: "privacy-policy",
      name: "PrivacyPolicy",
      component: () =>
        import(
          /* webpackChunkName: "privacy-policy" */ "@/views/PrivacyPolicy.vue"
        ),
    },
    {
      path: "blocked",
      name: "Blocked",
      component: () =>
        import(/* webpackChunkName: "blocked" */ "@/views/Blocked.vue"),
    },
    {
      path: "/:catchAll(.*)",
      component: () =>
        import(/* webpackChunkName: "not-found" */ "@/views/NotFound.vue"),
    },
  ],
};
